export enum LanguageEnum {
  EN = 'EN',
  AL = 'AL',
  SI = 'SI',
}
